import React from 'react';
import { useParams } from 'react-router-dom';

import { SchedulerReschedule } from 'components/Scheduler';

import './public-scheduler.scss';

const SchedulerReschedulePage = () => {
  const { bookingRef } = useParams();

  return (
    <div className="public-scheduler-page">
      <SchedulerReschedule
        bookingRef={bookingRef}
      />
    </div>
  );
};

export default SchedulerReschedulePage;
